/* Herb Garden hair quiz pop-up. Opens after the delay set in the theme editor, but only on a page where the welcome
   pop-up is not due (it always comes first), and never while the menu, the bag or the welcome pop-up is open or the
   shopper is typing. Closing it or opening the quiz keeps it away for the snooze days; taking the quiz keeps it away
   for good. Add ?thg_quiz_popup=1 to any URL to open it for testing. */
(function () {
  var SNOOZE_KEY = 'thg-qp-until';
  var QUIZ_KEY = 'thg-hair-quiz';

  function cookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split('=');
      if (kv[0] === name) return decodeURIComponent(kv.slice(1).join('='));
    }
    return '';
  }
  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { /* private mode */ }
    return null;
  }
  function snoozed() {
    var until = parseInt(store(SNOOZE_KEY) || '0', 10);
    return (until && Date.now() < until) || cookie('thg_qp') === '1';
  }
  function snooze(days) {
    store(SNOOZE_KEY, String(Date.now() + days * 864e5));
    document.cookie = 'thg_qp=1; path=/; max-age=' + Math.round(days * 86400) + '; SameSite=Lax';
  }
  function tookQuiz() {
    try { var s = JSON.parse(store(QUIZ_KEY) || 'null'); return !!(s && s.goal); } catch (e) { return false; }
  }

  function init(root) {
    if (!root || root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');
    var delay = parseFloat(root.getAttribute('data-delay'));
    var days = parseFloat(root.getAttribute('data-snooze'));
    if (isNaN(delay)) delay = 12;
    if (isNaN(days) || days <= 0) days = 3;
    var open = false;
    var timer = null;
    var hideTimer = null;

    function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') hide(true); }
    function show() {
      if (open) return;
      open = true;
      clearTimeout(hideTimer);
      root.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (open) root.classList.add('is-open'); });
      });
      document.addEventListener('keydown', onKey);
    }
    function hide(remember) {
      if (!open) return;
      open = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      if (remember) snooze(days);
      hideTimer = setTimeout(function () { if (!open) root.hidden = true; }, 360);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-qp-close]')) { e.preventDefault(); hide(true); return; }
      if (t.closest('[data-qp-go]')) snooze(days);
    });

    // Theme editor: open while the section is selected, never on a timer.
    if (window.Shopify && window.Shopify.designMode) {
      var sid = root.getAttribute('data-section');
      document.addEventListener('shopify:section:select', function (e) {
        if (root.isConnected && e.detail && e.detail.sectionId === sid) { window.__thgQpOpen = true; show(); }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (root.isConnected && e.detail && e.detail.sectionId === sid) { window.__thgQpOpen = false; hide(false); }
      });
      if (window.__thgQpOpen) show();
      return;
    }

    var test = false;
    try { test = new URLSearchParams(window.location.search).get('thg_quiz_popup') === '1'; } catch (e) {}
    if (test) { show(); return; }
    if (tookQuiz() || snoozed()) return;

    // The welcome pop-up comes first: if it is still due on this page, wait for the next one.
    var wp = document.getElementById('thg-wp');
    if (wp && !cookie('thg_wp') && wp.getAttribute('data-subscribed') !== '1') return;

    function busy() {
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
      if (document.documentElement.classList.contains('thg-wp-lock')) return true;
      return !!document.querySelector('.fm-drawer.is-open, [data-thg-drawer]:not([hidden]), [data-thg-cart]:not([hidden])');
    }
    function attempt() {
      if (busy()) { timer = setTimeout(attempt, 4000); return; }
      show();
    }
    timer = setTimeout(attempt, Math.max(0, delay) * 1000);
  }

  function boot() { init(document.getElementById('thg-qp')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('#thg-qp') : null;
    if (r) init(r);
  });
})();
